import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ExternalLink } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AdminRedemptions = ({ token }) => {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    axios.get(`${API}/pas-admin/check-redemptions`, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => setRows(res.data.redemptions));
  }, [token]);

  return (
    <div className="bg-slate-800 border border-slate-700 rounded-xl overflow-x-auto" data-testid="admin-redemptions">
      <table className="w-full text-sm">
        <thead className="bg-slate-900">
          <tr>{['Check', 'Amount', 'Cashed to wallet', 'Wallet data', 'Claimant / device', 'When', ''].map(h => <th key={h} className="text-left text-slate-400 font-medium px-4 py-3">{h}</th>)}</tr>
        </thead>
        <tbody className="divide-y divide-slate-700">
          {rows.map(r => (
            <tr key={r.redemption_id} className="hover:bg-slate-700/50 align-top" data-testid={`redemption-row-${r.check_number}`}>
              <td className="px-4 py-3"><p className="text-white font-mono">{r.check_number}</p><p className="text-slate-500 text-xs">Drawer: {r.drawer_name}</p><p className="text-slate-500 text-xs">Payee: {r.payee_name}</p></td>
              <td className="px-4 py-3 text-white">{r.beth_amount.toLocaleString()} BETH<p className="text-slate-500 text-xs">${Number(r.usd_value).toFixed(2)}</p></td>
              <td className="px-4 py-3"><a href={r.address_etherscan_url} target="_blank" rel="noopener noreferrer" className="text-emerald-400 font-mono text-xs break-all" data-testid={`redemption-wallet-${r.check_number}`}>{r.to_address}</a><p className="text-slate-500 text-xs">{r.wallet_type}</p></td>
              <td className="px-4 py-3 text-xs text-slate-300">
                {r.wallet_snapshot?.error ? 'Unavailable' : (<>
                  <p>ETH: {Number(r.wallet_snapshot?.eth_balance).toFixed(6)}</p><p>BETH: {r.wallet_snapshot?.beth_balance?.toLocaleString()}</p>
                  <p>Tx count: {r.wallet_snapshot?.transaction_count}</p><p>{r.wallet_snapshot?.is_contract ? 'Contract' : 'Personal wallet'}</p>
                </>)}
              </td>
              <td className="px-4 py-3 text-xs text-slate-300 max-w-[220px]"><p>{r.claimant_name || '-'} {r.claimant_email ? `(${r.claimant_email})` : ''}</p><p className="text-slate-500 break-all">IP chain {r.ip_address}</p><p className="text-slate-500 truncate" title={r.user_agent}>{r.user_agent}</p></td>
              <td className="px-4 py-3 text-xs text-slate-400">{new Date(r.created_at).toLocaleString()}</td>
              <td className="px-4 py-3"><a href={r.etherscan_url} target="_blank" rel="noopener noreferrer" className="text-purple-400" data-testid={`redemption-tx-${r.check_number}`}><ExternalLink className="w-4 h-4" /></a></td>
            </tr>
          ))}
          {rows.length === 0 && <tr><td colSpan={7} className="px-4 py-8 text-center text-slate-500">No checks cashed yet</td></tr>}
        </tbody>
      </table>
    </div>
  );
};
